import * as actionTypes from '../actions/actionTypes';

const initData = {
  blockUI: undefined,
  requestCounter: 0
}

export default function uiBlockerReducer(state = initData, action) {
  switch (action.type) {
    case actionTypes.BLOCK_UI: {
      return { ...state, blockUI: true };
    }
    case actionTypes.UN_BLOCK_UI: {
      return { ...state, blockUI: undefined, requestCounter: 0 };
    }
    case actionTypes.INCREMENT_BLOCK_COUNTER: {
      return { ...state, requestCounter: state.requestCounter + 1 };
    }
    case actionTypes.DECREMENT_BLOCK_COUNTER: {
      return { ...state, requestCounter: state.requestCounter >= 0 ? state.requestCounter - 1 : 0 };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uiBlockerReducer.js